import { Flex } from "~/components/Flex";
import { TableCell, Typography } from "@mui/material";

export const TicketsClosedCell = () => {
  return (
    <TableCell>
      <Flex flex="1 0 auto" justifyContent="flex-end" sx={{ pr: 3 }}>
        <Typography color="text.disabled" fontSize={13}>
          CLOSED
        </Typography>
      </Flex>
    </TableCell>
  );
};
